import { createFileRoute, Navigate } from '@tanstack/react-router';

/** `/me`: opens the user's profile, the first of the user pages (profile, security, notifications). */
export const Route = createFileRoute('/_auth/me/')({
  component: () => <Navigate to="/me/profile" replace />,
});
